import { T } from './translation-keys';

/**
 * Local text for aliases the backend does not ship yet. `translate()` falls back to the alias itself,
 * which would put a raw key in front of a player; these keep that from happening.
 */
export const TRANSLATION_FALLBACKS: Record<string, string> = {
  [T.RELOADING]: 'Reloading…',
  [T.GENERAL_ERROR_TITLE]: 'Error',
  [T.GENERAL_ERROR_TEXT]: 'Oops! Something went wrong on our end. Your previous progress is safe. Please try again.',
  [T.MAINTENANCE_NOTIFY_TEXT]: 'Your session will be interrupted in {{time}} seconds for maintenance purposes.',
  [T.MAINTENANCE_NOTIFY_AFTER_ROUND_TEXT]: 'Your session will be interrupted after the round is finished.',
};

/**
 * The one place an alias is resolved. `useTranslation` and `translationsStore.translate` both go
 * through it, so a key added here cannot work in one and print its raw alias in the other.
 */
export const resolveTranslation = (translations: Record<string, string> | undefined, alias: string): string =>
  translations?.[alias] || TRANSLATION_FALLBACKS[alias] || alias;
